import Papa from 'papaparse';

const convertCSVColumnstoFile = <T>({
  parsedCSV,
  columns,
  filename = `${Date.now()}`,
}: {
  parsedCSV: T[] | Papa.UnparseObject<T>;
  columns: string[];
  filename: string;
}) => {
  const csvString = Papa.unparse<T>(parsedCSV, { columns });
  return new File([csvString], filename, { type: 'text/csv' });
};

export default convertCSVColumnstoFile;
